import { memo } from 'react';
import { MemberUpdateTemplate } from 'components/templates/MemberUpdateTemplate';

type Props = {};

export const MemberUpdate = memo((_props: Props) => {
	return <MemberUpdateTemplate />;
});
